import React from "react";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Tooltip } from "@mui/material";
export function RefreshButton({handleRefresh}) {
  // const handleOnReload = () => {
  //   window.location.reload();
  // };

  return (
    <>
      <Tooltip title={"Refresh Data"} arrow="true" placement="right">
        <RefreshIcon onClick={handleRefresh} sx={{cursor:"pointer"}}/>
      </Tooltip>
    </>
  );
}
